import { FC, useEffect, useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import topicon from "../../../assets/top-icon.png";
import logo1 from "../../../assets/logo1.svg";
import logo from "../../../assets/logo.svg";
// @ts-ignore - CSS import declaration is provided by the project build configuration
import "../../../styles/styles.css";
import { useAuthService } from "../../../services";
import { PageUrl, SessionKey } from "../../../utils/app-config";
import { getMaintainance } from "../../../api/apimethods";
import { tr } from "date-fns/locale";
import ScamNotification from "../ScamNotification"
import { useConfig } from "../../../context/ConfigProvider";
import ImportantNote from "../ImportantNote"
import SystemMaintenance from "../SystemMaintenance"
export const Header: FC = () => {
  let isVisibleProfile = false;
  let isVisibleLogin = true;
  let isVisibleAddress = false;
  const cfg = useConfig();
  const UAT_AUTH_SCREEN = cfg.REACT_APP_UAT_AUTH_SCREEN;
  const [showMaintainance, setShowMaintainance] = useState(false);
  const [maintenanceMessage, setMaintenanceMessage] = useState("");
  const { logout } = useAuthService();
  const navigate = useNavigate();
  const authToken = localStorage?.getItem(SessionKey.AuthToken) ?? "";
  const storedAppData = localStorage.getItem(SessionKey.AppData) ?? "";

  if (!authToken) {
    isVisibleProfile = false;
    isVisibleLogin = true;
  } else {
    isVisibleProfile = true;
    isVisibleLogin = false;
    if (storedAppData) {
      const appData = JSON.parse(storedAppData);
      const defaultAddress = appData?.user.registeredAddresses?.[0];
      if (
        appData?.user &&
        appData?.user?.role === "ForeignerLogin" &&
        !defaultAddress?.streetName
      ) {
        isVisibleAddress = true;
      }
    }
  }

  const onClickLogout = () => {
    logout();
  };

  const onClickAccount = () => {
    navigate(PageUrl.Profile);
  };
  return (
    <header className="header">
      <div className="top-header">
         {/* Temp Message */}
       <SystemMaintenance />
        <div className="container">
          <p>
            <img src={topicon} alt="" className="img-fluid" /> A Singapore
            Government Agency Website{" "}
            <a
              className="btn btn-link govsg-btn"
              data-bs-toggle="collapse"
              href="#collapseGovsg"
              role="button"
              aria-expanded="false"
              aria-controls="collapseExample"
            >
              How to identify{" "}
              <span>
                <i className="fas fa-chevron-down"></i>
              </span>
            </a>
          </p>
          <div className="collapse" id="collapseGovsg">
            <div className="row justify-content-between govvia-style">
              <div className="col-md-5">
                <div className="d-flex me-3">
                  <span>
                    <div className="icon">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="17"
                        height="17"
                        viewBox="0 0 17 17"
                        fill="none"
                        className="banner-icon"
                      >
                        <path
                          d="M0.166016 5.6665V9.00067H0.999349V13.9998H0.166016V16.4998H0.999349H3.49935H5.16602H7.66601H9.33268H11.8327H13.4993L15.9993 16.5007V16.4998H16.8327V13.9998H15.9993V9.00067H16.8327V5.6665L8.49935 0.666504L0.166016 5.6665ZM3.49935 13.9998V9.00067H5.16602V13.9998H3.49935ZM7.66601 13.9998V9.00067H9.33268V13.9998H7.66601ZM13.4993 13.9998H11.8327V9.00067H13.4993V13.9998ZM10.166 5.6665C10.166 6.58651 9.41935 7.33317 8.49935 7.33317C7.57935 7.33317 6.83268 6.58651 6.83268 5.6665C6.83268 4.7465 7.57935 3.99984 8.49935 3.99984C9.41935 3.99984 10.166 4.7465 10.166 5.6665Z"
                          fill="#242425"
                        ></path>
                      </svg>
                    </div>
                  </span>
                  <div className="ms-2">
                    <h6 className="govsg-title">
                      Official website links end with .gov.sg
                    </h6>
                    <p className="govsg-body">
                      Government agencies communicate via{" "}
                      <strong>.gov.sg </strong>websites{" "}
                      <span className="avoidwrap">(e.g. go.gov.sg/open)</span>.{" "}
                      <a
                        href="https://go.gov.sg/trusted-sites"
                        className="d-inline-block trusted-websites"
                        target="_blank"
                        rel="noreferrer"
                        data-sf-ec-immutable=""
                      >
                        Trusted websites{" "}
                        <i className="fas fa-external-link-alt"></i>
                      </a>
                    </p>
                  </div>
                </div>
              </div>
              <div className="col-md-5">
                <div className="d-flex me-3">
                  <span>
                    <div className="icon d-inline-block">
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="15"
                        height="18"
                        viewBox="0 0 15 18"
                        fill="none"
                        className="banner-icon"
                      >
                        <path
                          d="M14.1663 9.00008C14.1663 8.08091 13.4188 7.33342 12.4997 7.33342H11.6663V4.83342C11.6663 2.53591 9.79717 0.666748 7.49967 0.666748C5.20217 0.666748 3.33301 2.53591 3.33301 4.83342V7.33342H2.49967C1.58051 7.33342 0.833008 8.08091 0.833008 9.00008V15.6667C0.833008 16.5859 1.58051 17.3334 2.49967 17.3334H12.4997C13.4188 17.3334 14.1663 16.5859 14.1663 15.6667V9.00008ZM4.99967 4.83342C4.99967 3.45508 6.12134 2.33341 7.49967 2.33341C8.87801 2.33341 9.99967 3.45508 9.99967 4.83342V7.33342H4.99967V4.83342Z"
                          fill="#242425"
                        ></path>
                      </svg>
                    </div>
                  </span>
                  <div className="ms-2">
                    <h6 className="govsg-title">Secure websites use HTTPS</h6>
                    <p className="govsg-body">
                      Look for a <strong>lock </strong>(
                      <span className="icon d-inline-block">
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="15"
                          height="18"
                          viewBox="0 0 15 18"
                          fill="none"
                          className="banner-icon"
                        >
                          <path
                            d="M14.1663 9.00008C14.1663 8.08091 13.4188 7.33342 12.4997 7.33342H11.6663V4.83342C11.6663 2.53591 9.79717 0.666748 7.49967 0.666748C5.20217 0.666748 3.33301 2.53591 3.33301 4.83342V7.33342H2.49967C1.58051 7.33342 0.833008 8.08091 0.833008 9.00008V15.6667C0.833008 16.5859 1.58051 17.3334 2.49967 17.3334H12.4997C13.4188 17.3334 14.1663 16.5859 14.1663 15.6667V9.00008ZM4.99967 4.83342C4.99967 3.45508 6.12134 2.33341 7.49967 2.33341C8.87801 2.33341 9.99967 3.45508 9.99967 4.83342V7.33342H4.99967V4.83342Z"
                            fill="#242425"
                          ></path>
                        </svg>
                      </span>
                      ) or https:// as an added precaution. Share sensitive
                      information only on official, secure websites.
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <ScamNotification />       
      </div>
      <div className="">
        {isVisibleAddress && (
          <nav className="navbar navbar-expand-lg navbar-light bg-light">
            <div className="container d-flex justify-content-center">
              <p className="mb-0 text-danger fw-bold text-center">
                Please update the address in the{" "}
                <Link
                  to="/profile"
                  className="text-danger text-decoration-underline"
                >
                  Account section
                </Link>
                .
              </p>
            </div>
          </nav>
        )}
        <nav className="navbar navbar-expand-lg navbar-light">
          <div className="container">
            <a className="navbar-brand" href="#">
              <img src={logo1} alt="NParks" className="img-fluid2" />
              <img src={logo} alt="AVS" className="img-fluid2" />
            </a>
            <button
              className="navbar-toggler"
              type="button"
              data-bs-toggle="collapse"
              data-bs-target="#navbarSupportedContent"
              aria-controls="navbarSupportedContent"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <span className="navbar-toggler-icon"></span>
            </button>
            <div
              className="collapse navbar-collapse"
              id="navbarSupportedContent"
            >
              <ul className="navbar-nav me-auto mb-2 mb-lg-0 ms-0 ms-lg-5">
                <li className="nav-item">
                  <a className="nav-link" href="/eservices">
                    Home
                  </a>
                </li>
              </ul>
              {isVisibleProfile && (
                <div className="d-flex">
                  <ul className="navbar-nav ms-md-auto mb-2 mb-lg-0">
                    <li className="nav-item dropdown">
                      <a
                        className="nav-link dropdown-toggle px-lg-0"
                        href="#"
                        id="navbarDropdown"
                        role="button"
                        data-bs-toggle="dropdown"
                        aria-expanded="false"
                      >
                        <svg
                          width="24"
                          height="24"
                          viewBox="0 0 24 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <g id="db-icon-profile">
                            <path
                              id="icon-profile"
                              fill-rule="evenodd"
                              clip-rule="evenodd"
                              d="M15.0049 14.0485L17.2371 15.3258C18.1581 15.8519 18.7562 16.793 18.8505 17.8372C20.1909 16.2657 21 14.2274 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 14.2274 3.80912 16.2657 5.14947 17.8372C5.2438 16.793 5.84188 15.8519 6.76214 15.3263L8.99366 14.0464C8.59608 13.4634 8.36364 12.7589 8.36364 12V10.1818C8.36364 8.17351 9.99169 6.54545 12 6.54545C14.0083 6.54545 15.6364 8.17351 15.6364 10.1818V12C15.6364 12.7598 15.4033 13.4651 15.0049 14.0485ZM14.3139 14.8053C13.6852 15.3245 12.879 15.6364 12 15.6364C11.1199 15.6364 10.3128 15.3237 9.68375 14.8034L7.25891 16.1942C6.56476 16.5907 6.13635 17.3288 6.13636 18.1282V18.8055H6.11032C7.68879 20.1727 9.74778 21 12 21C14.2522 21 16.3112 20.1727 17.8897 18.8055H17.8636V18.1282C17.8636 17.3288 17.4352 16.5907 16.7408 16.194L14.3139 14.8053ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14.6364C13.456 14.6364 14.6364 13.456 14.6364 12V10.1818C14.6364 8.72579 13.456 7.54545 12 7.54545C10.544 7.54545 9.36364 8.72579 9.36364 10.1818V12C9.36364 13.456 10.544 14.6364 12 14.6364Z"
                              fill="currentColor"
                            ></path>
                          </g>
                        </svg>
                      </a>
                      <ul
                        className="dropdown-menu  dropdown-menu-end"
                        aria-labelledby="navbarDropdown"
                      >
                        <li>
                          <button
                            className="tertiary-btn btn"
                            onClick={onClickAccount}
                          >
                            <svg
                              width="36"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <g id="db-icon-profile">
                                <path
                                  id="icon-profile"
                                  fill-rule="evenodd"
                                  clip-rule="evenodd"
                                  d="M15.0049 14.0485L17.2371 15.3258C18.1581 15.8519 18.7562 16.793 18.8505 17.8372C20.1909 16.2657 21 14.2274 21 12C21 7.02944 16.9706 3 12 3C7.02944 3 3 7.02944 3 12C3 14.2274 3.80912 16.2657 5.14947 17.8372C5.2438 16.793 5.84188 15.8519 6.76214 15.3263L8.99366 14.0464C8.59608 13.4634 8.36364 12.7589 8.36364 12V10.1818C8.36364 8.17351 9.99169 6.54545 12 6.54545C14.0083 6.54545 15.6364 8.17351 15.6364 10.1818V12C15.6364 12.7598 15.4033 13.4651 15.0049 14.0485ZM14.3139 14.8053C13.6852 15.3245 12.879 15.6364 12 15.6364C11.1199 15.6364 10.3128 15.3237 9.68375 14.8034L7.25891 16.1942C6.56476 16.5907 6.13635 17.3288 6.13636 18.1282V18.8055H6.11032C7.68879 20.1727 9.74778 21 12 21C14.2522 21 16.3112 20.1727 17.8897 18.8055H17.8636V18.1282C17.8636 17.3288 17.4352 16.5907 16.7408 16.194L14.3139 14.8053ZM12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22ZM12 14.6364C13.456 14.6364 14.6364 13.456 14.6364 12V10.1818C14.6364 8.72579 13.456 7.54545 12 7.54545C10.544 7.54545 9.36364 8.72579 9.36364 10.1818V12C9.36364 13.456 10.544 14.6364 12 14.6364Z"
                                  fill="currentColor"
                                ></path>
                              </g>
                            </svg>
                            <span className="logout-content">
                              View Account Details
                            </span>
                          </button>
                        </li>
                        <li>
                          <button
                            className="tertiary-btn btn"
                            onClick={onClickLogout}
                          >
                            <svg
                              width="24"
                              height="24"
                              viewBox="0 0 24 24"
                              fill="none"
                              xmlns="http://www.w3.org/2000/svg"
                            >
                              <path
                                fill-rule="evenodd"
                                clip-rule="evenodd"
                                d="M19.7929 11.5L16.2929 8L17 7.29289L21.7071 12L17 16.7071L16.2929 16L19.7929 12.5H9V11.5H19.7929ZM18.5 20.5V17.5H19.5V21.5H4.5V2.5H19.5V6.5H18.5V3.5H5.5V20.5H18.5Z"
                                fill="#647283"
                              ></path>
                            </svg>
                            <span className="logout-content">Logout</span>
                          </button>
                        </li>
                      </ul>
                    </li>
                  </ul>
                </div>
              )}
              {isVisibleLogin && (
                <form className="d-flex">
                  <a
                    href="/eservices/login"
                    className="btn btn-outline-success mb-4 mb-lg-0"
                    type="submit"
                  >
                    Login
                  </a>
                </form>
              )}
            </div>
          </div>
        </nav>
      </div>
    </header>
  );
};

export default Header;
